import { render, staticRenderFns } from "./RegistrationListView.vue?vue&type=template&id=09f71c4a&"
import script from "./RegistrationListView.vue?vue&type=script&lang=js&"
export * from "./RegistrationListView.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports